export default "__VITE_ASSET__BtMkw$$9__"